<template>
  <el-container style="height:650px;">
    <el-container style="height:100%">
      <el-aside width="20%" height="100%">
        <el-card class="box-card" style="padding:25px;height:100%;overflow:auto;">
          <el-input placeholder="搜索姓名" suffix-icon="el-icon-search" v-model="selName"></el-input>
          <el-tree
            ref="tree"
            :data="orgTreeWithStaff"
            show-checkbox
            :render-after-expand="false"
            node-key="Id"
            :props="treeProps"
            :default-expanded-keys="defaultexpanded"
            :filter-node-method="filterNode"
            @check-change="checkchange"
          >
            <span slot-scope="{ node, data }">
              <span>{{ node.label }} {{data.Type=="org"?'('+data.StaffCount+')':""}}</span>
            </span>
          </el-tree>
        </el-card>
      </el-aside>
      <el-main width="100%" height="100%" style="padding-top:0px;">
        <el-card class="box-card" style="padding:15px;height:100%;overflow:auto;">
          <el-form
            :rules="rules"
            ref="applyCheckFlowData"
            :model="applyCheckFlowData"
            label-width="150px"
          >
            <el-form-item label="流程类型:" required>
              <el-checkbox
                :indeterminate="isIndeterminate"
                v-model="checkAll"
                @change="handleCheckAllChange"
              >全选</el-checkbox>
              <el-checkbox-group
                :disabled="isCheckboxDisabled"
                style="width:100%"
                v-model="onCheckedTypesList"
                @change="handleCheckedTypesChange"
              >
                <el-checkbox
                  style="width:150px;margin:5px;"
                  size="mini"
                  v-for="(item,index) in entpApplyTypesList"
                  :label="item.Id"
                  :key="index"
                  border
                >{{item.Name}}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="流程名称:" prop="flowName">
              <el-input
                style="width:50%"
                v-model="applyCheckFlowData.flowName"
                placeholder="请填写流程名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="审批人:" prop="approverList">
              <el-select
                style="width:100%"
                v-model="approverList"
                filterable
                multiple
                @change="onApproverChange"
                @remove-tag="removeStaff"
              >
                <el-option
                  v-for="item in entpStaffsList"
                  :key="item.Id"
                  :label="item.Name"
                  :value="item.Id"
                ></el-option>
              </el-select>
              <el-radio style="width:100px" v-model="radioSelecter" :label="0">
                <span style="margin:10px;">
                  已选择
                  <span style="color:red">{{approverList.length}}</span> 人
                </span>
              </el-radio>
              <el-button type="text" size="medium" @click="removeAllStaff(approverList)">全部清除</el-button>
            </el-form-item>
            <el-form-item label="通知人:" prop="notifierList">
              <el-select
                style="width:100%"
                v-model="notifierList"
                filterable
                multiple
                @change="onNotifierChange"
                @remove-tag="removeStaff"
              >
                <el-option
                  v-for="item in entpStaffsList"
                  :key="item.Id"
                  :label="item.Name"
                  :value="item.Id"
                ></el-option>
              </el-select>
              <el-radio style="width:100px" v-model="radioSelecter" :label="1">
                <span style="margin:10px">
                  已选择
                  <span style="color:red">{{notifierList.length}}</span> 人
                </span>
              </el-radio>
              <el-button type="text" size="medium" @click="removeAllStaff(notifierList)">全部清除</el-button>
            </el-form-item>
            <el-form-item label="流程使用者(二选一):" required></el-form-item>
            <el-form-item label="选择部门:" prop="flowUserForOrgList">
              <el-cascader
                v-model="flowUserForOrgList"
                style="width:100%"
                :options="orgTree"
                :props="singleProps"
                @change="onflowUserChangeForOrg"
                filterable
              ></el-cascader>
            </el-form-item>
            <el-form-item label="选择员工:" prop="flowUserForStaffList">
              <el-select
                style="width:100%"
                v-model="flowUserForStaffList"
                filterable
                multiple
                @change="onflowUserChangeForStaff"
                @remove-tag="removeStaff"
              >
                <el-option
                  v-for="item in entpStaffsList"
                  :key="item.Id"
                  :label="item.Name"
                  :value="item.Id"
                ></el-option>
              </el-select>
              <el-radio style="width:100px" v-model="radioSelecter" :label="2">
                <span style="margin:10px">
                  已选择
                  <span style="color:red">{{flowUserForStaffList.length}}</span> 人
                </span>
              </el-radio>
              <el-button
                type="text"
                size="medium"
                @click="removeAllStaff(flowUserForStaffList)"
              >全部清除</el-button>
            </el-form-item>
            <el-form-item>
              <el-button size="medium" class="btn-primary" @click="submitApproval">提交</el-button>
              <el-button size="medium" class="btn-primary" @click="resetForm">重置</el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
export default {
  name: "",
  components: {},
  props: {
    flowId: {
      type: String,
      default: ""
    }
  },
  data() {
    let userMsg=this.$util.getLocalStorage("userMsg");
    return {
      isCheckboxDisabled: false,
      radioSelecter: 0,
      entpId: userMsg.EntpId,
      permission: this.$util.getPermission("Approval"),
      checkAll: false,
      isIndeterminate: true,
      applyCheckFlowDetail: {},
      entpApplyTypesList: [],
      defaultexpanded: [],
      treeProps: {
        children: "Childrens",
        label: "Name",
        value: "Id",
        multiple: true,
        emitPath: false
      },
      singleProps: {
        children: "Childrens",
        label: "Name",
        value: "Id",
        checkStrictly: true,
        emitPath: false,
        expandTrigger: "hover"
      },
      orgTree: [], //组织结构树
      orgTreeWithStaff: [], //组织树数据和员工
      selName: "",
      entpApplyTypesSearchData: {
        entpId: userMsg.EntpId,
        name: "",
        page: 1,
        limit: 1000
      },
      applyCheckFlowData: {
        id: "",
        entpId: userMsg.EntpId,
        applyTypeId: [],
        flowName: "",
        flowDesc: "",
        flowObjType: 0,
        flowObjRs: []
      },
      onCheckedTypesList: [],
      approverList: [], //审批人列表
      notifierList: [], //通知人列表
      flowUserForOrgList: [], //部门/使用者列表
      flowUserForStaffList: [],
      originEntpStaffsList: [],
      entpStaffsList: [], //企业员工列表
      removeStaffList: [],
      entpStaffsSearchData: {
        entpId: userMsg.EntpId,
        cascadeId: "",
        name: ""
      },
      filterNode(value, data) {
        if (!value) return true;
        return data.Name.indexOf(value) !== -1;
      },
      rules: {
        flowName: [
          { required: true, message: "请输入流程名称", trigger: "blur" }
        ],
        approverList: [
          {
            type: "array",
            required: true,
            message: "请选择审批人",
            trigger: "blur"
          }
        ]
      }
    };
  },
  watch: {
    selName(val) {
      this.$refs.tree.filter(val);
    },
    flowId(val) {
      this.resetForm();
      this.getEntpApplyCheckFlowDetail();
    },
    applyCheckFlowDetail(val) {
      this.isCheckboxDisabled = true;
      this.applyCheckFlowData = {
        id: val.Id,
        entpId: this.entpId,
        applyTypeId: [val.ApplyTypeId],
        flowName: val.FlowName,
        flowDesc: val.FlowDesc,
        flowObjType: val.FlowObjType,
        flowObjRs: []
      };
      this.onCheckedTypesList = [];
      this.onCheckedTypesList.push(val.ApplyTypeName.Id);
      this.isCheckboxDisabled = true;
      let flowobjrs = val.FlowObjRs;

      let approverList = [];
      let notifierList = [];
      let flowUserForStaffList = [];
      let flowUserForOrgList = [];
      for (let index = 0; index < flowobjrs.length; index++) {
        let element = flowobjrs[index];

        //0 使用对象
        if (element.ObjType == "0") {
          if (val.FlowObjType == 0) {
            this.flowUserForOrgList.push(element.Id);
          } else if (val.FlowObjType == 1) {
            flowUserForStaffList.push(element.Id);
            this.onflowUserChangeForStaff(flowUserForStaffList);
          }
          //1 审批人
        } else if (element.ObjType == "1") {
          approverList.push(element.Id);
          this.onApproverChange(approverList);
          //2 通知人
        } else if (element.ObjType == "2") {
          notifierList.push(element.Id);
          this.onNotifierChange(notifierList);
        }
      }
    },
    deep: true
  },
  created() {
    this.getSubOrgTree();
    this.getOrgTreeWithStaff();
    this.getEntpStaffsSelectList();
    this.getEntpApplyTypesList();
  },
  mounted() {},
  methods: {
    //提交
    submitApproval() {
      this.applyCheckFlowData.applyTypeId = this.onCheckedTypesList;

      if (this.flowUserForOrgList.length > 0) {
        this.applyCheckFlowData.flowObjType = 0;
        for (let index = 0; index < this.flowUserForOrgList.length; index++) {
          let element = this.flowUserForOrgList[index];
          this.applyCheckFlowData.flowObjRs.push({
            objType: 0,
            objId: element,
            sequence: index + 1
          });
        }
      } else {
        if (this.flowUserForStaffList.length > 0) {
          this.applyCheckFlowData.flowObjType = 1;
          for (
            let index = 0;
            index < this.flowUserForStaffList.length;
            index++
          ) {
            let element = this.flowUserForStaffList[index];
            this.applyCheckFlowData.flowObjRs.push({
              objType: 0,
              objId: element,
              sequence: index + 1
            });
          }
        }
      }
      if (this.approverList.length > 0) {
        for (let index = 0; index < this.approverList.length; index++) {
          let element = this.approverList[index];
          this.applyCheckFlowData.flowObjRs.push({
            objType: 1,
            objId: element,
            sequence: index + 1
          });
        }
      }
      if (this.notifierList.length > 0) {
        for (let index = 0; index < this.notifierList.length; index++) {
          let element = this.notifierList[index];
          this.applyCheckFlowData.flowObjRs.push({
            objType: 2,
            objId: element,
            sequence: index + 1
          });
        }
      }
      this.editApplyCheckFlow();
    },
    //流程类型全选
    handleCheckAllChange(val) {
      let that = this;
      if (val) {
        this.entpApplyTypesList.forEach(element => {
          that.onCheckedTypesList.push(element.Id);
        });
      } else {
        this.onCheckedTypesList = [];
      }
      this.isIndeterminate = false;
    },
    //流程类型勾选
    handleCheckedTypesChange(val) {
      let checkedCount = val.length;
      this.checkAll = checkedCount === this.entpApplyTypesList.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.entpApplyTypesList.length;
    },
    //选择审批人
    onApproverChange(val) {
      this.approverList = this.duplicateCheck(val);
    },
    //选择通知人
    onNotifierChange(val) {
      this.notifierList = this.duplicateCheck(val);
    },
    //选择流程使用者-适用员工
    onflowUserChangeForStaff(val) {
      this.flowUserForOrgList = [];
      this.flowUserForStaffList = this.duplicateCheck(val);
    },
    //选择流程使用者-适用部门
    onflowUserChangeForOrg(val) {
      this.removeAllStaff(this.flowUserForStaffList);
    },
    //取消选中的员工,还原到员工列表
    removeStaff(Id) {
      for (let index = 0; index < this.removeStaffList.length; index++) {
        let element = this.removeStaffList[index];
        if (element.Id == Id) {
          this.$refs.tree.setChecked(element.Id, false, true);
          this.entpStaffsList.push(element);
          this.removeStaffList.splice(index, 1);
        }
      }
    },
    //取消选中某一列所有员工
    removeAllStaff(list) {
      for (let i = 0; i < list.length; i++) {
        let id = list[i];
        for (let index = 0; index < this.removeStaffList.length; index++) {
          let element = this.removeStaffList[index];
          if (element.Id == id) {
            this.$refs.tree.setChecked(element.Id, false, true);
            this.entpStaffsList.push(element);
            this.removeStaffList.splice(index, 1);
          }
        }
      }
      if (list === this.approverList) {
        this.approverList = [];
      } else if (list === this.notifierList) {
        this.notifierList = [];
      } else if (list === this.flowUserForStaffList) {
        this.flowUserForStaffList = [];
      }
    },
    //找已选中的员工,从员工列表中删掉
    duplicateCheck(val) {
      if (val.length > 0) {
        for (let i = 0; i < val.length; i++) {
          let vId = val[i];
          for (let j = 0; j < this.entpStaffsList.length; j++) {
            let staffId = this.entpStaffsList[j].Id;
            if (vId == staffId) {
              this.$refs.tree.setChecked(vId, true, true);

              this.removeStaffList = this.removeStaffList.concat(
                this.entpStaffsList.splice(j, 1)
              );
            }
          }
        }
      }
      return val;
    },
    //找已选中的员工,从员工列表中删掉
    duplicateCheckForOrgTree(val) {
      if (val.length > 0) {
        let result = [];
        for (let i = 0; i < val.length; i++) {
          let vId = val[i].Id;
          for (let j = 0; j < this.entpStaffsList.length; j++) {
            let staffId = this.entpStaffsList[j].Id;
            if (vId == staffId) {
              result.push(vId);
              this.removeStaffList = this.removeStaffList.concat(
                this.entpStaffsList.splice(j, 1)
              );
            }
          }
        }
        return result;
      }
    },
    //组织结构树选中节点
    checkchange(data, checked, indeterminate) {
      if (checked) {
        let checkedNodes = this.$refs.tree.getCheckedNodes(true, false);
        let tempList = this.duplicateCheckForOrgTree(checkedNodes);
        switch (this.radioSelecter) {
          case 0:
            this.approverList = this.approverList.concat(tempList);
            break;
          case 1:
            this.notifierList = this.notifierList.concat(tempList);
            break;
          case 2:
            this.flowUserForStaffList = this.flowUserForStaffList.concat(
              tempList
            );
            break;
        }
      } else if (!checked && !indeterminate) {
        if (data.Type == "staff") {
          for (let i = 0; i < this.approverList.length; i++) {
            let element = this.approverList[i];
            if (element == data.Id) {
              this.approverList.splice(i, 1);
            }
          }
          for (let j = 0; j < this.notifierList.length; j++) {
            let element = this.notifierList[j];
            if (element == data.Id) {
              this.notifierList.splice(j, 1);
            }
          }
          for (let k = 0; k < this.flowUserForStaffList.length; k++) {
            let element = this.flowUserForStaffList[k];
            if (element == data.Id) {
              this.flowUserForStaffList.splice(k, 1);
            }
          }
          this.removeStaff(data.Id);
        }
      }
    },
    resetForm() {
      this.applyCheckFlowData = {
        id: "",
        entpId: this.entpId,
        applyTypeId: [],
        flowName: "",
        flowDesc: "",
        flowObjType: 0,
        flowObjRs: []
      };
      this.onCheckedTypesList = [];
      this.approverList = [];
      this.notifierList = [];
      this.flowUserForOrgList = [];
      this.flowUserForStaffList = [];
      this.removeStaffList = [];
      this.entpStaffsList = JSON.parse(this.originEntpStaffsList);
      this.$refs.tree.setCheckedKeys([]);
    },
    //获取假期类型
    getEntpApplyTypesList() {
      this.$util
        .axiosGet({
          url: "/api/AttendanceSystem/GetEntpApplyTypesList",
          data: this.entpApplyTypesSearchData
        })
        .then(res => {
          this.dataCount = res.count;
          if (res.data) {
            this.entpApplyTypesList = res.data;
          }
        })
        .catch(err => {});
    },
    //获取企业员工
    getEntpStaffsSelectList() {
      this.$util
        .axiosGet({
          url: "/api/AttendanceSystem/GetEntpStaffsSelectList",
          data: this.entpStaffsSearchData
        })
        .then(res => {
          if (res.data) {
            this.originEntpStaffsList = JSON.stringify(res.data);
            this.entpStaffsList = res.data;
          }
        })
        .catch(err => {});
    },
    //获取组织结构和员工
    getOrgTreeWithStaff() {
      this.$util
        .axiosGet({
          url: "/api/AttendanceSystem/GetOrgTreeWithStaff",
          data: { entpId: this.entpId }
        })
        .then(res => {
          if (res.data) {
            if (res.data[0].Id == null) {
              res.data[0].Id = "1";
            }
            this.orgTreeWithStaff = res.data;
            this.defaultexpanded = [res.data[0].Id];
          }
        })
        .catch(err => {});
    },
    //获取组织结构
    getSubOrgTree() {
      this.$util
        .axiosGet({
          url: "/api/AttendanceSystem/GetSubOrgTree",
          data: { entpId: this.entpId }
        })
        .then(res => {
          if (res.data) {
            if (res.data[0].Id == null) {
              res.data[0].Id = "1";
            }
            this.orgTree = this.getTreeData(res.data);
            this.defaultexpanded = [res.data[0].Id];
          }
        })
        .catch(err => {});
    },
    // 数列
    getTreeData(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].Childrens.length < 1) {
          data[i].Childrens = undefined;
        } else {
          this.getTreeData(data[i].Childrens);
        }
      }
      return data;
    },
    //编辑流程
    editApplyCheckFlow() {
      let that = this;
      this.$util
        .axiosPost({
          url: "/api/AttendanceSystem/EditApplyCheckFlow",
          data: this.applyCheckFlowData
        })
        .then(res => {
          if (res.errcode == 0) {
            this.$util.successMsg("更新成功");
          }
        })
        .catch(err => {});
    },
    //获取流程详情
    getEntpApplyCheckFlowDetail() {
      this.$util
        .axiosGet({
          url:
            "/api/AttendanceSystem/GetEntpApplyCheckFlowDetail?flowId=" +
            this.flowId
        })
        .then(res => {
          if (res.data) {
            //
            this.applyCheckFlowDetail = res.data;
          }
        })
        .catch(err => {});
    }
  }
};
</script>
<style lang="less" scoped>
</style>
